export enum SnackConfigMessageType {
  Error = 1,
  Warn,
  Normal,
}

interface SnackConfigProps {
  open?: boolean;
  message?: string;
  type?: SnackConfigMessageType;
}

class SnackConfig {
  open: boolean;
  message: string;
  type: SnackConfigMessageType;

  constructor({ open, message, type }: SnackConfigProps) {
    this.open = open || false;
    this.message = message || '';
    this.type = type || SnackConfigMessageType.Error;
  }
}

export default SnackConfig;
